var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBtn',_vm._g({attrs:{"icon":""}},_vm.$listeners),[_c('v-icon',[_vm._v(_vm._s(_vm.$store.state.icons.close))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }